const normalizeText = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/\(.*?\)/g, " ")
    .replace(
      /\b(city|county|town|village|municipality|state|fl|florida|of|the)\b/g,
      "",
    )
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const buildCandidateStrings = ({
  municipality,
  taxDistrictDscr,
  taxDistrict,
  city,
  municipalities,
}) => {
  const candidates = [];

  if (municipality?.mun_name) {
    candidates.push(municipality.mun_name);
  }

  if (municipality?.mun_slug) {
    candidates.push(String(municipality.mun_slug).replace(/_/g, " "));
  }

  if (taxDistrictDscr) {
    candidates.push(taxDistrictDscr);
  }

  const matchingMunicipality = (municipalities || []).find((mun) => {
    const munName = normalizeText(mun?.mun_name);
    const munSlug = normalizeText(
      String(mun?.mun_slug || "").replace(/_/g, " "),
    );
    const district = normalizeText(taxDistrict);
    return district && (munSlug === district || munName === district);
  });

  if (matchingMunicipality?.mun_name) {
    candidates.push(matchingMunicipality.mun_name);
  }

  if (city) {
    candidates.push(city);
  }

  return candidates.filter(Boolean);
};

export const resolveMunicipalityMatch = ({
  cities = [],
  municipality = null,
  taxDistrictDscr = "",
  taxDistrict = "",
  city = "",
  municipalities = [],
}) => {
  const candidateStrings = buildCandidateStrings({
    municipality,
    taxDistrictDscr,
    taxDistrict,
    city,
    municipalities,
  });

  for (const candidate of candidateStrings) {
    const normalizedCandidate = normalizeText(candidate);
    if (!normalizedCandidate) continue;

    const matchedCity = cities.find((cityName) => {
      const normalizedCity = normalizeText(cityName);
      if (!normalizedCity) return false;
      return (
        normalizedCity === normalizedCandidate ||
        normalizedCity.startsWith(normalizedCandidate) ||
        normalizedCandidate.startsWith(normalizedCity)
      );
    });

    if (matchedCity) {
      return matchedCity;
    }
  }

  return "";
};

export const normalizeMunicipalityText = normalizeText;
